<template>
  <div id="buttonHeaders">
    <input ref="switchInput" type="checkbox" data-toggle="switchbutton" v-model="modeButton"
      data-onlabel="<i class='fa fa-sun'></i>" data-offlabel="<i class='fa fa-moon'></i>" data-onstyle="primary"
      data-offstyle="dark" />
    <ButtonTop :link="getThinlinc()" :target="'_blank'" :title="'ThinLinc'" :image="'thinlinc'"
      v-if="!!!this.$nlhpc.getUser().is_ir" />
    <ButtonTop :link="'https://wiki.nlhpc.cl'" :target="'_blank'" :title="'Wiki NLHPC'"
      :icon="'fab fa-wikipedia-w fa-lg'" />
    <ButtonTop :target="'_blank'" :link="'https://wiki.nlhpc.cl/Generador_Scripts'" :title="'Generador de Scripts'"
      :icon="'fas fa-robot fa-lg'" />
    <ButtonTop :link="'#'" :title="'Iniciar visita guiada'" :icon="'far fa-lightbulb'" @click="openIntroJS()" />
    <ButtonTop v-if="token" :link="'/solicitudes'" :title="'Solicitudes'" :icon="'fas fa-envelope-open fa-lg'" />
    <ButtonTop id="ssh" v-if="token && !!!this.$nlhpc.getUser().is_ir" link="#" :title="'Consola SSH'"
      :icon="'fas fa-terminal fa-lg'" @click="open()" />
    <ButtonNotification v-if="token" />
  </div>
</template>

<!-- eslint-disable no-undef -->
<script>
import ButtonNotification from "@/components/ButtonNotification.vue";
import ButtonTop from "@/components/ButtonTop.vue";
import "@/assets/css/switchbutton.css";
import "@/assets/js/switchbutton.js";

export default {
  name: "HeaderButtons",
  components: {
    ButtonNotification,
    ButtonTop,
  },
  data() {
    return {
      modeButton: true,
      user: null,
    };
  },

  props: {
    token: {
      type: String,
      default: null,
    },
    fromFather: {
      type: Boolean,
      default: true,
    },
  },

  watch: {
    modeButton(newValue) {
      let value = newValue ? "light" : "dark";
      this.changeMode(value);
    },
    fromFather() {
      this.modeButton = this.modeButton ? false : true;
    },
  },

  methods: {
    async changeMode(theme) {
      document.documentElement.setAttribute("data-theme", theme);
      localStorage.setItem("_theme", theme);
      window.dispatchEvent(new Event("storage"));
    },

    open() {
      let url = `https://ssh.dashboard.nlhpc.cl/?username=${this.token}`;
      let target = "_blank";
      let width = 890;
      let height = 860;
      let location = `left=${screen.width / 2},top=${screen.height / 2}`;
      let size = `width=${width},height=${height}`;
      if (screen.width <= 1024) size = "fullscreen=1";
      let options = `${location},${size},resizable=1,status=0,toolbar=0,menubar=0,scrollbars=1,titlebar=0`;

      window.open(url, target, options);
    },

    openIntroJS() {
      localStorage.setItem("showAgain", true);
      location.href = "/";
    },

    openScript() {
      $("#modalScript").modal("show");
    },

    getThinlinc() {
      if (!this.$nlhpc.isLoggedIn()) return "https://thinlinc.nlhpc.cl:300";
      return `https://thinlinc.nlhpc.cl:300/?username=${this.user.usuario}`;
    },

    initSwitch() {
      this.$nextTick(() => {
        const input = this.$refs.switchInput;
        if (input && typeof input.switchButton !== "function") {
          import("@/assets/js/switchbutton.js").then(() => input.switchButton());
        } else if (input && input.switchButton) input.switchButton();
      });
    },
  },

  mounted() {
    let modeOS = window.matchMedia("(prefers-color-scheme:dark)").matches
      ? "dark"
      : "light";
    let mode = localStorage.getItem("_theme") || modeOS;
    this.modeButton = mode == "light" ? true : false;
    this.changeMode(mode);
    this.initSwitch();
  },

  updated() {
    this.initSwitch();
  },

  created() {
    this.user = this.$nlhpc.getUser();
  },
};
</script>
